import { HttpEvent, HttpHandlerFn, HttpRequest, HttpContextToken } from '@angular/common/http';
import { Observable } from 'rxjs';
import { fuseLoadingInterceptor } from '@fuse/services/loading/loading.interceptor';

/**
 * Token HTTP Context pour désactiver le loading sur des requêtes spécifiques
 * Utilisé pour le polling et les requêtes en arrière-plan
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

/**
 * Wrapper de l'intercepteur Fuse Loading qui ajoute la capacité de skip le loading
 * Permet de désactiver le loading bar pour des requêtes spécifiques via SKIP_LOADING
 * 
 * Usage :
 * ```typescript
 * const context = new HttpContext().set(SKIP_LOADING, true);
 * this.http.get(url, { context }).subscribe(...);
 * ```
 */
export const customLoadingInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    // Si SKIP_LOADING est activé, bypass l'interceptor Fuse
    if (req.context.get(SKIP_LOADING)) {
        return next(req);
    }

    // Déléguer à l'interceptor Fuse original
    return fuseLoadingInterceptor(req, next);
};
